// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"Chats_col-md-4__AlCYn","oChatsSectionBlock":"Chats_oChatsSectionBlock__NAW4Z"};